'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _htmlPlayer_controlsHtml = require('./html/player_controls.html');

var _htmlPlayer_controlsHtml2 = _interopRequireDefault(_htmlPlayer_controlsHtml);

var PlayerControlsDirective = function PlayerControlsDirective() {
    _classCallCheck(this, PlayerControlsDirective);

    this.template = _htmlPlayer_controlsHtml2['default'];
    this.restrict = 'E';
    this.controller = 'PlayerControlsController';
};

exports['default'] = PlayerControlsDirective;

PlayerControlsDirective.$inject = [];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/player_controls_directive.js
 ** module id = 47
 ** module chunks = 0
 **/